/*
/	Corentin BOUTON — Junior Mines Provence 2023
/	contact@junior-mines-provence.fr
/	https://junior-mines-provence.fr
*/

import { Stack, ButtonGroup, ToggleButton, Image } from 'react-bootstrap';

import { Titre, Item } from '../Fonctions';

/// Sécurités
import sans_secu from "../../images/sans_secu.webp";
import eclats from "../../images/eclats.webp";
import effraction from "../../images/effraction.webp";
import complete from "../../images/complete.webp";

function Securite({ securite, setSecurite }) {
	const debug = false;

	return (
		<Stack gap={2}>
			<Titre>Sécurité</Titre>
			<ButtonGroup style={{ width: '95%' }}>
				<ToggleButton
					id='sans'
					type="radio"
					variant={'outline-dark'}
					name="sans"
					checked={securite === 0}
					onClick={(e) => setSecurite(0)}>
					<Stack gap={2}>
						<Item>Aucune</Item>
						<Image src={sans_secu} rounded style={securite !== 0 ? { width: '20%', display: 'block', margin: 'auto' } : { width: '20%', display: 'block', margin: 'auto', filter: 'invert(100%)'}}/>
					</Stack>
				</ToggleButton>
				<ToggleButton
					id='eclats'
					type="radio"
					variant={'outline-dark'}
					name="eclats"
					checked={securite === 1}
					onClick={(e) => setSecurite(1)}>
					<Stack gap={2}>
						<Item>Éclats intérieurs</Item>
						<Image src={eclats} rounded style={securite !== 1 ? { width: '20%', display: 'block', margin: 'auto' } : { width: '20%', display: 'block', margin: 'auto', filter: 'invert(100%)'}}/>
					</Stack>
				</ToggleButton>
				<ToggleButton
					id='effraction'
					type="radio"
					variant={'outline-dark'}
					name="effraction"
					checked={securite === 2}
					onClick={(e) => setSecurite(2)}>
					<Stack gap={2}>
						<Item>Effraction</Item>
						<Image src={effraction} rounded style={securite !== 2 ? { width: '20%', display: 'block', margin: 'auto' } : { width: '20%', display: 'block', margin: 'auto', filter: 'invert(100%)'}}/>
					</Stack>
				</ToggleButton>
				<ToggleButton
					id='complete'
					type="radio"
					variant={'outline-dark'}
					name="complete"
					checked={securite === 3}
					onClick={(e) => setSecurite(3)}>
					<Stack gap={2}>
						<Item>Complète (éclats + effraction)</Item>
						<Image src={complete} rounded style={securite !== 3 ? { width: '20%', display: 'block', margin: 'auto' } : { width: '20%', display: 'block', margin: 'auto', filter: 'invert(100%)'}} alt='securite-img'/>
					</Stack>
				</ToggleButton>
			</ButtonGroup>
			{debug ? securite : null}
		</Stack>
	);
}

export default Securite;
